import { useParams } from 'react-router-dom'

import { ClassMaterialsFileViewerDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { FileViewer as Viewer } from 'modules/trainings/components/Files/FileViewer'

export default function ClassMaterialsFileViewer() {
  const { id, classId, classFileId } = useParams()
  const { navigation } = useNavigation()

  // TODO: We're fetching trough the training class because there's an id mismatch
  // between the training class and the training class file at the entity level
  const { data, loading } = useQuery(ClassMaterialsFileViewerDocument, {
    variables: { id: Number(classId) },
  })

  if (loading) return null

  const files =
    data?.trainings.trainingClass?.classFilesConnection.nodes.map((classFile) => ({
      id: classFile.id,
      filename: classFile.filename,
      title: classFile.title || classFile.filename,
      contentType: classFile.contentType,
      url: classFile.url,
      fileUrl: classFile.url,
      type: 'trainingClass' as const,
    })) || []

  const file = files?.find((f) => f.id === Number(classFileId))

  if (!file) {
    throw new Error('File not found')
  }

  return (
    <Viewer
      file={file}
      files={files}
      urlBackTo={navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.fullPath(
        {
          id: String(id),
          classId: String(classId),
        }
      )}
      goNextFile={(f) =>
        navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.previewFile.fullPath(
          {
            id: String(id),
            classId: String(classId),
            classFileId: f.id,
          }
        )
      }
      goPrevFile={(f) =>
        navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.previewFile.fullPath(
          {
            id: String(id),
            classId: String(classId),
            classFileId: f.id,
          }
        )
      }
    />
  )
}
